import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CollapsibleSection from '../../../../shared/components/CollapsibleSection';
import { formatDuration } from './utils';
import type { ReconcilerPlumbingStep } from '../../../../types/frontend';

export interface PlumbingSectionProps {
  plumbing: ReconcilerPlumbingStep[];
}

const PlumbingSection: React.FC<PlumbingSectionProps> = ({ plumbing }) => {
  const [expanded, setExpanded] = useState(false);

  if (!plumbing.length) return null;

  const total = plumbing.reduce((s, p) => s + p.duration_ms, 0);

  return (
    <CollapsibleSection
      title={`Infrastructure · ${formatDuration(total)}`}
      expanded={expanded}
      onChange={setExpanded}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        {plumbing.map((step, i) => (
          <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.disabled">
              {step.display_name}
            </Typography>
            <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'text.disabled' }}>
              {formatDuration(step.duration_ms)}
            </Typography>
          </Box>
        ))}
      </Box>
    </CollapsibleSection>
  );
};

export default PlumbingSection;
